import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/site/Header";
import { HomeSection, ServicesSection, ProjectsSection, AboutSection, ContactSection, Footer } from "@/components/site/Sections";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="site">
        <Header />
        <main className="site-main">
          <Routes>
            <Route path="/" element={<HomeSection />} />
            <Route path="/services" element={<ServicesSection />} />
            <Route path="/projects" element={<ProjectsSection />} />
            <Route path="/about" element={<AboutSection />} />
            <Route path="/contact" element={<ContactSection />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
